<template>
  <div class="content impact-content">
    <div class="header">
      <h1 class="h1">Donation Button Widget</h1>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <textarea class="form-control" name="widget" cols="50" rows="7" :value="jsTemplateV2"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
  import donateButtonMixin from './donate-button-mixin';
  import {mapState} from "vuex";

  export default {
    name: 'DonateButtonWidget',
    mixins: [donateButtonMixin],
    metaInfo: {
      title: 'Donation Button Widget',
    },
    mounted() {
      this.attachJsExampleV2();
    },
    beforeDestroy() {
      this.deleteElement('.h-widget-wrap');
      this.deleteElement('.test-script-wrap');
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
    },
    watch: {
      'activeCharityId'() {
        this.attachJsExampleV2();
      },
    },
  };
</script>

